import { jsx as _jsx } from "react/jsx-runtime";
import "@fontsource/source-sans-3";
import "@fontsource/source-sans-3/700.css";
import "@fontsource/source-sans-3/400-italic.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/styles.scss";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { ConfigCatProvider, createConsoleLogger, LogLevel, PollingMode, } from "configcat-react";
import { Provider } from "react-redux";
import store from "./app/providers/redux/store";
import { App } from "./App";
const mount = (container) => {
    const root = createRoot(container);
    const options = {
        logger: process.env.NODE_ENV === "development"
            ? createConsoleLogger(LogLevel.Info)
            : undefined,
        pollIntervalSeconds: 10,
        maxInitWaitTimeSeconds: 2,
    };
    root.render(_jsx(ConfigCatProvider, { sdkKey: process.env.SDK_CNFCT || "", pollingMode: PollingMode.AutoPoll, options: options, children: _jsx(HashRouter, { children: _jsx(Provider, { store: store, children: _jsx(App, {}) }) }) }));
};
const e = document.getElementById("root");
if (e) {
    mount(e);
}
